// extracted by mini-css-extract-plugin
export default {"root":"mAZF70It--CircleArrowButton_root__V6hG9","arrow":"mAZF70It--CircleArrowButton_arrow__y8dTi","left":"mAZF70It--CircleArrowButton_left__goLOQ"};